import angular from 'angular';

export function lazyLoadModule(loader) {
  return (transition) => {
    const $injector = transition.injector().get('$injector');
    return loader().then((mod) => {
      const moduleName = mod.default;
      const rootModule = angular.module('app');
      if (rootModule.requires.indexOf(moduleName) === -1) {
        rootModule.requires.push(moduleName);
      }
      return $injector.loadNewModules([moduleName]);
    });
  };
}
